import React, { useContext } from "react";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import logo from "../../../../assets/images/logo.png";
import { StoreContext } from "../../../../App";
import { stringAvatar } from "../../../../utils";
import { observer } from "mobx-react-lite";

const Header = observer(() => {
  const { auth } = useContext(StoreContext);
  const user = auth.user;
  const username = `${user?.fullNameUA.firstName} ${
    user?.fullNameUA.lastName
  } ${user?.fullNameUA.middleName || ""}`.trim();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const pages = [
    {
      title: "Користувачі",
      link: "/cabinet/users",
      external: true,
      roles: ["HR"],
    },
    {
      title: "Оргструктура",
      link: "/cabinet/org-structure",
      external: true,
      roles: ["HR"],
    },
    {
      title: "Електронні форми",
      link: `/cabinet/forms`,
      external: true,
      roles: [],
    },
    {
      title: "Контакти",
      link: "/contact",
      external: false,
    },
  ];

  const settings = [
    {
      title: "Профіль",
      link: `/cabinet/users/${user?._id}`,
      external: false,
      roles: [],
    },
    {
      title: "Редагувати",
      link: `/cabinet/users/${user?._id}/edit`,
      external: false,
      roles: [],
    },
    {
      title: "Вийти",
      link: "/logout",
      external: false,
      roles: [],
    },
  ];

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const getVisiblePages = () => {
    return pages.filter((page) => {
      if (!user?._id && page.roles?.length > 0) return false;
      if (
        user?._id &&
        page.roles?.length > 0 &&
        page.roles.find((role) => role === user?.accountType) === undefined
      )
        return false;
      return true;
    });
  };

  const visiblePages = getVisiblePages();

  return (
    <AppBar position="static" sx={{ height: "56px" }}>
      <Container maxWidth="xl">
        <Toolbar
          disableGutters
          variant="dense"
          sx={{ minHeight: 56, alignItems: "center" }}
        >
          <Link to={"/"} sx={{ display: { xs: "none", md: "flex" }, mr: 1 }}>
            <Avatar
              src={logo}
              alt={"SUITT лого"}
              variant="square"
              sx={{ height: "40px" }}
            />
          </Link>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {visiblePages.map((page) => (
                <MenuItem
                  component={Link}
                  to={page.link}
                  key={page.link}
                  onClick={handleCloseNavMenu}
                >
                  <Typography textAlign="center">{page.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box
            sx={{
              marginLeft: 5,
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              alignItems: "center",
            }}
          >
            {visiblePages.map((page) => (
              <Button
                component={Link}
                to={page.link}
                key={page.link}
                onClick={handleCloseNavMenu}
                sx={{ my: 0, mx: 1, color: "white", display: "block" }}
              >
                {page.title}
              </Button>
            ))}
          </Box>
          {user?._id ? (
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Відкрити налаштування">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt={username} {...stringAvatar(username)} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    component={Link}
                    to={setting.link}
                    key={setting.link}
                    onClick={handleCloseUserMenu}
                  >
                    <Typography textAlign="center">{setting.title}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          ) : (
            <Box
              sx={{
                marginLeft: 5,
                flexGrow: 0,
                display: { xs: "none", md: "flex" },
                alignItems: "center",
              }}
            >
              <Button
                component={Link}
                to={"/login"}
                color="secondary"
                sx={{
                  my: 0,
                  mr: 2,
                  color: "white",
                  display: "block",
                  textAlign: "center",
                }}
              >
                Вхід
              </Button>
              <Button
                component={Link}
                variant="outlined"
                to={"/register"}
                sx={{
                  my: 0,
                  color: "white",
                  borderColor: "white",
                  display: "block",
                }}
              >
                Реєстрація
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
});

export default Header;
